import { jsxs as p, jsx as e } from "react/jsx-runtime";
import { cx as j } from "class-variance-authority";
import * as s from "react";
import { cn as c } from "../../utils.js";
import { EyeClosed as k, EyeSolid as L } from "iconoir-react";
import { ErrorMessage as P } from "../ErrorMessage/index.js";
import { Typography as C } from "../Typography/index.js";
import { InputLabel as O } from "../InputLabel/index.js";
const R = s.forwardRef(
  ({
    className: x,
    label: f,
    type: l,
    id: t,
    rounded: m = !1,
    endIcon: a,
    startIcon: u,
    errors: i,
    dense: h,
    required: g,
    helperText: b,
    inputClassName: y,
    ...r
  }, v) => {
    const S = s.useId();
    t = t || S;
    const [n, N] = s.useState(!1), E = () => N((d) => !d);
    return s.useEffect(() => {
      const d = t.replace(/:/g, "\\:"), o = document.querySelector(`input[type=number]#${d}`), w = (F) => F.preventDefault();
      return o && o.addEventListener("wheel", w), () => {
        o && o.removeEventListener("wheel", w);
      };
    }, [t]), l === "password" && a === void 0 && (a = /* @__PURE__ */ e(
      "button",
      {
        title: n ? "Hide password" : "Show password",
        type: "button",
        onClick: E,
        className: "flex items-center justify-center",
        children: n ? /* @__PURE__ */ e(k, {}) : /* @__PURE__ */ e(L, {})
      }
    )), /* @__PURE__ */ p("div", { className: c("relative w-full", x), children: [
      f && /* @__PURE__ */ e(O, { label: f, required: g, htmlFor: t }),
      /* @__PURE__ */ p(
        "div",
        {
          className: c(
            "flex h-[44px] w-full items-center rounded-md border border-onSurface-800 bg-white ring-interactive-400 focus-within:ring-2 focus-within:ring-offset-1",
            { "bg-onSurface-100": r.disabled },
            { "rounded-full": m, "h-4.5": h },
            { "border-critical-500 bg-critical-50": !!i },
            {
              "cursor-pointer": l === "file" && !r.disabled && !r.readOnly
            }
          ),
          children: [
            u && /* @__PURE__ */ e(
              "label",
              {
                htmlFor: t,
                className: j("shrink-0 ps-1", {
                  "text-[#acacac] disabled:opacity-50": r.disabled
                }),
                children: u
              }
            ),
            /* @__PURE__ */ e(
              "input",
              {
                id: t,
                type: n ? "text" : l,
                className: c(
                  "w-full grow rounded-md bg-transparent px-1.5 py-1 text-body placeholder-onSurface-400 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
                  { "rounded-full": m, "h-4.5": h },
                  {
                    "cursor-pointer": l === "file" && !r.disabled && !r.readOnly
                  },
                  y
                ),
                ref: v,
                ...r
              }
            ),
            a && /* @__PURE__ */ e("label", { htmlFor: t, className: "shrink-0 pe-1", children: a })
          ]
        }
      ),
      !i && b && /* @__PURE__ */ e(C, { variant: "smallBody", className: "mt-0.5 text-onSurface-500", children: b }),
      i && /* @__PURE__ */ e(P, { title: i })
    ] });
  }
);
R.displayName = "TextField";
export {
  R as TextField
};
